import { useEffect, useState } from "react";
import {
  completeCertificate,
  fetchCertificate,
  uploadCertificate,
  type CertificateView,
} from "../../api/certificate";
import { Banner } from "../../components/Banner";
import { ScreenState } from "../../components/ScreenState";
import { attempt } from "../../lib/errors";
import { useAsync } from "../../lib/useAsync";
import { CertificateScreen } from "../../screens/certificate/CertificateScreen";
import { DoneScreen } from "./DoneScreen";

export function CertificateRoute() {
  const loaded = useAsync(fetchCertificate, []);
  const [view, setView] = useState<CertificateView | null>(null);
  const [busy, setBusy] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (loaded.data) setView(loaded.data);
  }, [loaded.data]);

  if (finished) {
    return (
      <DoneScreen
        kicker="Growth Pathway complete"
        title="You've completed the Growth Pathway."
        sub="The Gig Board is now open: real gigs in your skill, refreshed every few hours. If you're on the finance track, your handover to the provider is open too."
        next={{ to: "/gig/6", label: "Open the Gig Board" }}
      />
    );
  }

  return (
    <ScreenState loading={loaded.loading} error={loaded.error} onRetry={loaded.reload}>
      {view ? (
        <>
          {error ? <Banner tone="bad">{error}</Banner> : null}
          <CertificateScreen
            view={view}
            uploading={uploading}
            uploadError={uploadError}
            busy={busy}
            onUpload={(file) =>
              void attempt(setUploading, setUploadError, async () =>
                setView(await uploadCertificate(file)),
              )
            }
            onComplete={() =>
              void attempt(setBusy, setError, async () => {
                const wasDone = view.done;
                setView(await completeCertificate());
                if (!wasDone) setFinished(true);
              })
            }
          />
        </>
      ) : null}
    </ScreenState>
  );
}
